import { HTTPClient, propsToDate} from '@abaco/web-common/src/HTTP';
import { Granularity, SensorItem, SensorWithReadings } from '../models/SensorModel';
import { SensorXResponse } from '../models/StationModel';
import { SensorPosition, SensorReading } from '../models/SensorDataModel';

export default class SensorApi {
    private http: HTTPClient;
    private path: string;

    constructor(http: HTTPClient, path: string) {
        this.http = http;
        this.path = path;
    }

    public async getSensorsItems(pkCuaa: number, stationId: string) {
        const res = await this.http.get<SensorXResponse<SensorItem>>(

            `/${this.path}/v1/farm/${pkCuaa}/stations/${stationId}/sensors`, {
        })

        res.data.results.forEach((el) => propsToDate(el, ['date']))
        // res.data.results.push({type: 'DEFAULT', stationId: res.data.results[0].stationId, id: 'image', name: 'Image', unit: null, dataType: 'S', date: new Date(), value: 'https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_735,h_490/https://www.omnesgroup.com/wp-content/uploads/2020/07/obscure-programming.jpg'})
        return res.data.results;
    }

    public async getSensorItemAggregated(pkCuaa: number, stationId: string, granularity: Granularity, from: Date, to: Date) {
        const params = {
            from,
            to,
            getSingleValue: false
        }
        const res = await this.http.get<SensorXResponse<SensorWithReadings>>(`/${this.path}/v1/farm/${pkCuaa}/stations/${stationId}/sensors/${granularity}`, {params})
        res.data.results.forEach((el) => el.dates = el.dates.map(dt => new Date(dt)))
        return res.data.results;
    }

    public async getSensorsPositions(pkCuaa: number, physicalQuantity: string): Promise<SensorReading[]> {
        const curDate = new Date();
        const formatted = `${curDate.toISOString().split('.')[0]}Z`;
        //const formatted = `2023-05-01T00:00:00Z`;
        const res = await this.http.get(
            `/${this.path}/v1/farm/${pkCuaa}/physical-quantity/${physicalQuantity}/readings?crs=EPSG:4326&date=${formatted}`, {
        })
        return res.data && res.data.results ? res.data.results : [];
    }
}
